import { Component } from "@angular/core";
import {
  IonicPage,
  LoadingController,
  NavController,
  NavParams,
} from "ionic-angular";
import { ShopperBuyProductPayScanConfirmPage } from "../shopper-buy-product-pay-scan_confirm/shopper-buy-product-pay-scan_confirm";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ServiceProvider } from "../../providers/service/service";
import { Http, RequestOptions, Headers } from "@angular/http";
import { Storage } from "@ionic/storage";

/**
 * Generated class for the ShopperBuyProductPayInputPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-shopper-buy-product-pay-input",
  templateUrl: "shopper-buy-product-pay-input.html",
})
export class ShopperBuyProductPayInputPage {
  private code: FormGroup;
  theme = 1;
  plaza_id = "";
  merchant_id = "";
  items = "";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {
    this.code = this.formBuilder.group({
      val: ["", Validators.compose([Validators.required])],
    });

    this.plaza_id = this.navParams.data.plaza_id;
    this.merchant_id = this.navParams.data.merchant_id;
    this.items = this.navParams.data.items;
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
  }

  /** submit code */
  confirm() {
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });

    if (!this.code.value.val) {
      this.translateService
        .get("Code must not be empty.")
        .subscribe((value) => {
          this.services.presentToast(value);
        });
      return false;
    } else {
      loader.present();

      const itemArr = [];

      for (let i = 0; i < this.items.length; i++) {
        itemArr.push({ shop_id: this.items[i], qty: 1 });
      }

      this.storage.get("token").then((token) => {
        var postData = {
          plaza_id: this.plaza_id,
          code: this.code.value.val,
          items: itemArr,
          merchant_id: this.merchant_id,
        };
        var link = this.services.URLShopperBuyShop; // change link
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });
        this.http
          .post(link, postData, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              loader.dismiss();
              this.navCtrl.push(ShopperBuyProductPayScanConfirmPage, {
                result: data.discount,
                data: data,
                code: postData,
                plaza_id: this.plaza_id,
                merchant_id: this.merchant_id,
              });
            },
            (error) => {
              var response = JSON.parse(error._body);
              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
              loader.dismiss();
            }
          );
      });
    }
  }

  backPage() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-product-pay-input/shopper-buy-product-pay-input.ts